import { Dictionary } from "flow/api/types";
import environment from "flow/configuration/environment";

function generateAttrObjectFromManifest(manifest: any) {
    if (!manifest || !environment.debug()) {
        return {};
    }

    return {
        "data-lc-id": manifest.id || "undefined",
        "data-lc-vm": manifest.viewModelId || "undefined",
        "data-lc-view": manifest.viewUrl || "undefined"
    };
}

function setAttributes(element: Element, attributes: Dictionary) {
    if (element.nodeType !== 8) {
        // Safeguard against element being an html comment
        Object.keys(attributes).forEach(function (key) {
            element.setAttribute(key, attributes[key]);
        });
    }
}

export default {
    generateAttrObjectFromManifest: generateAttrObjectFromManifest,
    setAttributes: setAttributes
};
